module.exports = "/assets/data/6056c5499b33521b629255c8d1f56416-CF38.data.json";